const Footer = () => {
	return (
		<>
			<footer>
				<div className="footer-wrapper">
					<h1>Designed by Nicolas Godeau @ Le Reacteur</h1>
					<a href="https://github.com/Nixoals" target={'_blank'} rel="noopener noreferrer">
						<ion-icon name="logo-github"></ion-icon>
					</a>
					<a href="https://www.linkedin.com/in/nicolas-g-a68b3846/" target={'_blank'} rel="noopener noreferrer">
						<ion-icon name="logo-linkedin"></ion-icon>
					</a>
					<a href="https://nicolasgodeau.fr/" target={'_blank'} rel="noopener noreferrer">
						<ion-icon name="globe-outline"></ion-icon>
					</a>
				</div>
			</footer>
		</>
	);
};

export default Footer;
